import { render, staticRenderFns } from "./client-view.vue?vue&type=template&id=642dfce5&scoped=true"
import script from "./client-view.vue?vue&type=script&lang=js"
export * from "./client-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642dfce5",
  null
  
)

export default component.exports